import { render, staticRenderFns } from "./TsPageTitle.vue?vue&type=template&id=20956350&"
import script from "./TsPageTitle.vue?vue&type=script&lang=js&"
export * from "./TsPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports